import React, { useEffect, useState } from 'react';

import {
  headersTermoReferenciaOrgInter,
  valoresExibidosTermoReferenciaOrgInter,
} from './auxiliarTermoReferencia';
import BarraInferiorBotoes from '../../../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CustomButton from '../../../../../../../components/CustomButton';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import Input from '../../../../../../../components/InputNew';
import Select from '../../../../../../../components/InputNew/Select';
import Log from '../../../../../../../components/Log/Log';
import Modal from '../../../../../../../components/Modal';
import Tabela from '../../../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import { useStatusOrgInter } from '../../../../../../../services/enum/useStatusOrgInter';
import httpClient, {
  isHttpError,
} from '../../../../../../../services/httpClient';
import { getTermoReferenciaPorOrgInter } from '../../../../../../../services/orgInters/orgInterTermoReferenciaService';
import theme from '../../../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../../../utils/swal';
import { useOrgInterDadosGerais } from '../../context/dadosGeraisContext';
import ItemCotacao from '../cotacao';
import OrdemCompra from '../ordemCompra';

type TermoReferenciaType = {
  id: number;
  usuarioId: number;
  orgInterId: number;
  statusTermoRef: number;
  dataTermoRef: string;
  termoReferencia: string;
  observacoes: string;
};

export default function TermosReferenciasOrgInter() {
  const { componente, orgInter, userID } = useOrgInterDadosGerais();
  //////STATES
  const [logData, setLogData] = useState<any>();
  const statusOrgInter = useStatusOrgInter();
  const [showModal, setShowModal] = useState(false);
  const [termoReferenciaId, setTermoReferenciaId] = useState('');
  const [updatingTermoReferencia, setUpdatingTermoReferencia] = useState(false);

  const [data, setData] = useState<any[]>();
  const [formTermoReferencia, setFormTermoReferencia] =
    useState<TermoReferenciaType>({
      id: 0,
      usuarioId: userID,
      orgInterId: orgInter,
      statusTermoRef: 0,
      dataTermoRef: '',
      termoReferencia: '',
      observacoes: '',
    });

  //////FETCH DATA
  const fetchTermoReferencia = async () => {
    try {
      const termos = await getTermoReferenciaPorOrgInter(String(orgInter));
      setData(termos);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };
  useEffect(() => {
    fetchTermoReferencia();
  }, []);

  //////TABLE E OFFCANVAS
  const tableData =
    data
      ?.slice() // faz uma cópia para não mutar o array original
      .sort(
        (a, b) =>
          new Date(a.dataTermoRef).getTime() -
          new Date(b.dataTermoRef).getTime(),
      )
      .map((item) => {
        // Definindo cores de fundo com base no status do documento
        let statusBackgroundColor = '';
        let colorText = 'black';

        const statusLabel = statusOrgInter[item.statusTermoRef].label;

        if (statusLabel === 'Em Elaboração') {
          statusBackgroundColor = theme.colors.amarelogov;
          colorText = 'white';
        } else if (statusLabel === 'Em Execução') {
          statusBackgroundColor = theme.colors.azulgov;
          colorText = 'white';
        } else if (statusLabel === 'Finalizado') {
          statusBackgroundColor = theme.colors.verdegov;
          colorText = 'white';
        } else if (statusLabel === 'Suspenso') {
          statusBackgroundColor = theme.colors.laranja;
          colorText = 'white';
        } else if (statusLabel === 'Cancelado') {
          statusBackgroundColor = theme.colors.vermelho;
          colorText = 'white';
        }
        return {
          id: item.id,
          statusTermoRef: (
            <span
              style={{
                backgroundColor: statusBackgroundColor,
                color: colorText,
                borderRadius: '10px',
                padding: '12px',
                display: 'inline-block',
                minWidth: '100px',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              {statusLabel}
            </span>
          ),
          termoReferencia: item.termoReferencia || 'Não informado',
          dataTermoRef: formatDateSimp(item.dataTermoRef),
        };
      }) || [];

  const offCanvasData =
    data?.map((item) => {
      // Definindo cores de fundo com base no status do documento
      let statusBackgroundColor = '';
      let colorText = 'black';

      const statusLabel = statusOrgInter[item.statusTermoRef].label;

      if (statusLabel === 'Em Elaboração') {
        statusBackgroundColor = theme.colors.amarelogov;
        colorText = 'white';
      } else if (statusLabel === 'Em Execução') {
        statusBackgroundColor = theme.colors.azulgov;
        colorText = 'white';
      } else if (statusLabel === 'Finalizado') {
        statusBackgroundColor = theme.colors.verdegov;
        colorText = 'white';
      } else if (statusLabel === 'Suspenso') {
        statusBackgroundColor = theme.colors.laranja;
        colorText = 'white';
      } else if (statusLabel === 'Cancelado') {
        statusBackgroundColor = theme.colors.vermelho;
        colorText = 'white';
      }

      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        statusOrgInter: (
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              color: colorText,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              minWidth: '100px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {statusLabel}
          </span>
        ),
        termoReferencia: item.termoReferencia || 'Não informado',
        dataTermoRef: formatDateSimp(item.dataTermoRef),
        separadorValores: '',
        observacoes: item.observacoes,
      };
    }) || [];

  //////FUNÇÕES HANDLE
  const handleClearForm = () => {
    setFormTermoReferencia({
      id: 0,
      usuarioId: userID,
      orgInterId: orgInter,
      statusTermoRef: 0,
      termoReferencia: '',
      dataTermoRef: '',
      observacoes: '',
    });
    setLogData({
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleShowModal = () => setShowModal((prev) => !prev);

  const handleClickInserirNovoTermoRef = () => {
    handleClearForm();
    setUpdatingTermoReferencia(false);
    handleShowModal();
  };

  const handleRowClickTermoRef = (id: string) => {
    setTermoReferenciaId(id);
    setUpdatingTermoReferencia(true);
    setShowModal(true);

    const itemSelecionado = data?.find((d) => d.id === id);
    if (itemSelecionado) {
      const dataTermoRef = itemSelecionado.dataTermoRef
        ? new Date(itemSelecionado.dataTermoRef).toISOString().split('T')[0]
        : '';

      setFormTermoReferencia({
        id: itemSelecionado.id,
        usuarioId: userID,
        orgInterId: orgInter,
        statusTermoRef: itemSelecionado.statusTermoRef || 0,
        dataTermoRef: dataTermoRef,
        termoReferencia: itemSelecionado.termoReferencia || 'Não informado',
        observacoes: itemSelecionado.observacoes || '',
      });

      setLogData({
        id: itemSelecionado.id,
        usuarioRegistro: itemSelecionado.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          itemSelecionado.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: itemSelecionado.dataRegistro,
        dataAtualizacao: itemSelecionado.dataUltimaAtualizacao,
        nEdicoes: itemSelecionado.nEdicoes,
      });
    }
  };

  //////FUNÇÕES CRUD
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    const novoValor = value;

    setFormTermoReferencia((prev: TermoReferenciaType) => ({
      ...prev,
      [name]: novoValor,
    }));
  };

  const adjustFormTermoRefBeforeSubmit = (form: any) => {
    const adjustedForm = {
      ...form,
      statusTermoRef: Number(form.statusTermoRef),
      dataTermoRef: form.dataTermoRef ? new Date(form.dataTermoRef) : null,
      //Observações
      observacoes:
        form.observacoes === ''
          ? 'Sem observações específicas.'
          : form.observacoes,
    };

    return adjustedForm;
  };

  const validateForm = (form: any) => {
    const erros = [];
    if (!form.statusTermoRef || form.statusTermoRef === '0')
      erros.push('<b>Status do TR</b> é obrigatório.');
    if (!form.dataTermoRef) erros.push('<b>Data do TR</b> é obrigatório.');
    if (!form.termoReferencia)
      erros.push('<b>Nº do Termo de Referência</b> é obrigatório.');

    if (erros.length > 0) {
      swalAttention(erros.join('<br>'));
      return false;
    }

    return true;
  };

  const handleCreateTR = async () => {
    try {
      if (!validateForm(formTermoReferencia))
        throw new Error('Formulário inválido.');

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormTermoRefBeforeSubmit(formTermoReferencia);

      await httpClient.post(`/api/orginter-termoreferencia`, adjustedForm);
      swalSave();
      fetchTermoReferencia();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(formTermoReferencia))
        throw new Error('Formulário inválido.');

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormTermoRefBeforeSubmit(formTermoReferencia);

      const response = await httpClient.patch(
        `/api/orginter-termoreferencia/${termoReferenciaId}`,
        adjustedForm,
      );
      swalAtualizacao('Sucesso', response.data.message);
      fetchTermoReferencia();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await httpClient.delete(
        `/api/orginter-termoreferencia/${termoReferenciaId}`,
      );
      swalDeleteConfirm();
      fetchTermoReferencia();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  //USE EFFECT
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const laranja = '#faca71dd';
    const amarelo = '#faffb4dd';
    const azul = '#acbaff';

    const status = String(formTermoReferencia.statusTermoRef);

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? azul
            : status === '3'
              ? verde
              : status === '4'
                ? laranja
                : status === '5'
                  ? vermelho
                  : 'white',
    };
    setStatusStyle(newStatusStyle);
  }, [formTermoReferencia.statusTermoRef]);

  return (
    <BoxConteudo boxTitulo="Termos de Referências (TRs)">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headersTermoReferenciaOrgInter}
            dataTable={tableData}
            displayValues={valoresExibidosTermoReferenciaOrgInter}
            onRowClick={handleRowClickTermoRef}
            dataOffCanvas={offCanvasData}
            botaoAbrirOffCanvas={false}
            showPagination={false}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            setUpdatingTermoReferencia(false);
            handleClickInserirNovoTermoRef();
          }}
        />
      </CustomCol>

      {/* Modal Termo de Referência /*/}
      <Modal
        tituloModal="Termo de Referência (TR)"
        open={showModal}
        onHide={handleShowModal}
      >
        <WorkspaceFicha>
          <Log
            {...logData}
            entity="TB_ORG_INTER_TERMO_REF"
            id={Number(formTermoReferencia.id)}
          />

          {/* Identificação do TR */}
          <BoxConteudo boxTitulo="Identificação do TR">
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="250px">
                <Select
                  name="statusTermoRef"
                  options={statusOrgInter}
                  label="Status"
                  value={formTermoReferencia.statusTermoRef}
                  onChange={handleChange}
                  style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  id="termoReferencia"
                  name="termoReferencia"
                  label="Nº do Termo de Referência"
                  value={formTermoReferencia.termoReferencia}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="190px">
                <Input
                  id="dataTermoRef"
                  name="dataTermoRef"
                  type="date"
                  value={formTermoReferencia.dataTermoRef}
                  label="Data do TR"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  value={formTermoReferencia.observacoes}
                  label="Observações"
                  linhas={5}
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Cotação REQ */}
          <ItemCotacao
            termoRefId={
              formTermoReferencia.id ? Number(formTermoReferencia.id) : 0
            }
          ></ItemCotacao>

          {/* Ordem de Compra (APO) */}
          <OrdemCompra
            termoRefId={
              formTermoReferencia.id ? Number(formTermoReferencia.id) : 0
            }
          ></OrdemCompra>

          <BarraInferiorBotoes>
            {updatingTermoReferencia ? (
              <WorkspaceBotoes
                delete
                // deleteDisabled={btDisable}
                onClickDelete={handleDelete}
                save
                // saveDisabled={btDisable}
                onClickSave={handleUpdate}
              />
            ) : (
              <WorkspaceBotoes
                inserir
                // inserirDisabled={btDisable}
                onClickInserir={handleCreateTR}
              />
            )}
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </Modal>
    </BoxConteudo>
  );
}
